import { DetailsPanel } from '@/components/controls';
import { useOptionLookup } from '@/hooks';
import { startCase } from '@/utils';
import { Box, Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import { Popup } from 'react-map-gl/maplibre';

export function AlertPopup({
  hoverInfo: {
    longitude,
    latitude,
    feature: { properties },
  },
}) {
  const vehicleGroups = useOptionLookup('vehicleGroup');

  return (
    <Popup
      longitude={longitude}
      latitude={latitude}
      offset={16}
      closeButton={false}
    >
      <Stack spacing={0.5}>
        <Stack
          direction="row"
          spacing={1}
          sx={{ alignItems: 'center', justifyContent: 'space-between' }}
        >
          <Typography variant="subtitle2">Accelerometer Alert</Typography>
          {properties.vehicle?.registrationNumber && (
            <Box
              sx={{
                fontSize: 10,
                color: 'secondary.contrastText',
                bgcolor: 'secondary.main',
                borderRadius: 1,
                px: 0.5,
                fontWeight: 'bold',
              }}
            >
              {properties.vehicle?.registrationNumber}
            </Box>
          )}
        </Stack>
        <Typography variant="caption" color="textSecondary">
          {format(new Date(properties.time), 'dd/MM HH:mm:ss')}
        </Typography>
        {properties.vehicle && (
          <DetailsPanel
            title="Vehicle"
            entries={[
              { label: 'Fleet #', value: properties.vehicle.fleetNumber },
              { label: 'Role', value: properties.vehicle.role },
              { label: 'Home Station', value: properties.vehicle.homeStation },
              ...Object.entries(properties.vehicle?.groups ?? {}).map(
                ([type, codes = []]) => ({
                  label: vehicleGroups[type]?.label ?? startCase(type),
                  value: codes.join?.(', ') ?? codes,
                }),
              ),
            ]}
          />
        )}
      </Stack>
    </Popup>
  );
}
